import { render, staticRenderFns } from "./editPencil.vue?vue&type=template&id=06050406&"
import script from "./editPencil.vue?vue&type=script&lang=js&"
export * from "./editPencil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports